<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded-4 shadow border-0">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-colonial">toggle_on</span>
          {{ title }}
        </h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="onCancel()"></button>
      </div>

      <div class="modal-body">
        <p *ngIf="description" class="text-muted small">{{ description }}</p>

        <label class="form-label small" for="statusSelect">Estado</label>
        <select id="statusSelect" class="form-select" [(ngModel)]="selected">
          <option value="" disabled>Seleccione...</option>
          <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
        <button type="button" class="btn bg-colonial btn-secondary" (click)="onConfirm()"
          [disabled]="unchanged">Actualizar</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>
